<template>
  <div :style="{ height: pageHeight + 'px' }">
    <van-nav-bar
      fixed
      title="个人信息"
      left-text=""
      right-text=""
      left-arrow
      @click-left="onClickLeft"
    />
    <div class="mybox" :style="{ height: pageHeight+ 'px' }" style="margin-top:46px;">
      <div class="myitem laybox changebox changeface">
        <van-uploader  :deletable="false" :after-read="Uploader"  v-show="false">
          <van-image
          round fit="cover"
          width="154px"
          height="154px"
          :src="imgSrc"
        />
        <!-- <img width="154px" :src="imgSrc" alt=""> -->

        <!-- <h3  @click="show = false">更换头像</h3> -->
        <!-- <input type="file" name="header_img" accept="image/gif,image/jpeg,image/png,image/jpg"> -->

            <!-- <img width="154px" :src="imgSrc" alt=""> -->
        </van-uploader>
        <!-- <van-action-sheet
          v-model="show"
          :actions="actions"
          cancel-text="取消"
          close-on-click-action
          @select="onSelect"
        /> -->
         <!-- <input type="file" accept="image/*" class="hide_file" ref ="leftFile" id="upload"  @change="getFile($event)"> -->
        <input type="file" accept="image/*" capture="camera"  class="hide_file" ref ="leftFile" id="upload"  @change="getFile($event)">
        <div class="camera" @click="clickFile">
          <div>
            <img v-if="img" class="bigImg" :src="img" alt="">
            <img v-if="!img" class="icon" :src="imgSrc" alt="">
          </div>
            <h3 v-if="!img" class="text">更换头像</h3>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import Vue from 'vue'
import { Tabbar, TabbarItem, Col, Row, Image as VanImage, NavBar, Cell, CellGroup, Button, ActionSheet, Uploader, Toast } from 'vant'
import axios from 'axios'

// import axios from 'axios' // 引入axios进行前后端交互
Vue.use(Tabbar, TabbarItem, Col, Row, VanImage, NavBar, Cell, CellGroup, Button, ActionSheet, Uploader, Toast)

export default {
  name: 'changeFacePage',
  components: {
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Col.name]: Col,
    [Row.name]: Row,
    [VanImage.name]: VanImage,
    [NavBar.name]: NavBar,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    [ActionSheet.name]: ActionSheet,
    [Uploader.name]: Uploader,
    [Toast.name]: Toast
  },
  created () {
    this.cpName = this.$route.query.cpname
    this.phoneNum = this.$route.query.phoneNum
    this.getimgSrc()
  },
  methods: {
    // 更新头像
    setUserImages () {
      return window.config.baseUrl+'/showTXImg?phoneNum=' + this.phoneNum// 用户头像接口
    },
    getimgSrc () {
      this.imgSrc = window.config.baseUrl+'/showTXImg?phoneNum=' + this.phoneNum// 用户头像接口
    },
    onClickLeft () {
      this.$router.go(-1)// 返回上一页面
    },
    onSelect (item) {
      // 默认情况下点击选项时不会自动收起
      // 可以通过 close-on-click-action 属性开启自动收起
      this.show = false
      if (item.name === '拍照') {
        this.fileUpload()
      } else {
      }
    },
    // 上传图片
    Uploader (file) {
      this.util.post('/uploadTXImg', {
        file: file.content
      }).then(({ data }) => {
        if (data.code === 200) {
          this.util.toast(data.msg)
          location.reload()// 刷新页面
        } else {
          return Promise.reject(new Error(data.message || data.msg || '系统错误，请稍后再试。'))
        }
      })
    },
    // base64 转文件
    convertBase64UrlToBlob (urlData) {
      let arr = urlData.split(','); let mime = arr[0].match(/:(.*?);/)[1]
      let bstr = atob(arr[1]); let n = bstr.length; let u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], { type: mime })
    },
    // 图片压缩 //path是指上传的图片，obj是压缩的品质，越低越模糊
    handlerImageFiles (path, obj) {
      // console.log(obj)
      return new Promise((ones, tows) => {
        let img = new Image()
        // console.log(img)
        img.src = path
        img.onload = function () {
          // 默认按比例压缩
          let w = img.width
          let h = img.height
          let quality = 0.7 // 默认图片质量为0.7
          // 生成canvas
          let canvas = document.createElement('canvas')
          let ctx = canvas.getContext('2d')
          canvas.width = w
          canvas.height = h
          // 在canvas绘制前填充白色背景
          ctx.fillStyle = '#fff'
          ctx.fillRect(0, 0, canvas.width, canvas.height)
          ctx.drawImage(this, 0, 0, w, h)
          // quality值越小，所绘制出的图像越模糊
          let base64 = canvas.toDataURL('image/jpeg', quality)
          // 回调函数返回base64的值
          ones(base64)
        }
        // console.log(img)
      })
    },
    // 获取图片宽高
    handlerGetImagesInfo (src) {
      return new Promise((ones, twos) => {
        let images = new Image()
        images.src = src
        images.onload = ev => {
          const { width, height } = images
          ones({ width, height })
        }
      })
    },
    // 获取选择的图片文件上传
    async getFile (e) {
      let file = this.$refs.leftFile.files[0]
      let paths = URL.createObjectURL(file)
      let ImagesInfo = await this.handlerGetImagesInfo(paths)
      let maxSize = 2 * 1024 * 1024 // 自己定义的文件大小，超过多少M就开始压缩(现在是2M)
      let param = new FormData() // 创建form对象
      let newfilesBase = await this.handlerImageFiles(paths, { ...ImagesInfo, quality: 0.1 }) // 这里拿到的是base64  需要转成file
      let newfilesblob = this.convertBase64UrlToBlob(newfilesBase)
      let newfiles = new window.File([newfilesblob], '图片.jpg', { type: 'image/jpeg' }) // 上传这个文件
      if (file.size > maxSize) {
        param.append('file', newfiles)// 通过append向form对象添加数据 //newfiles
      } else {
        // 没有大于2兆直接执行
        param.append('file', file)// 通过append向form对象添加数据
      }
      // console.log(file)
      // console.log(newfiles)
      // alert(file.size + '---' + newfiles.size)
      // alert(newfiles.size)

      // let newfilesBase = await this.handlerImageFiles(paths, { ...ImagesInfo, quality: 0.8 }) // 这里拿到的是base64  需要转成file
      // let newfilesblob = this.convertBase64UrlToBlob(newfilesBase)
      // let newfiles = new window.File([newfilesblob], '图片.jpg', { type: 'image/jpeg' }) // 上传这个文件
      // let param = new FormData() // 创建form对象
      // param.append('file', newfiles)// 通过append向form对象添加数据 //newfiles
      // console.log(file)
      // 你觉得就一个file参数，就可以了？
      param.append('phoneNum', this.phoneNum)
      // console.log(file.name)
      // // param.append('id', this.token)
      // console.log(file)

      // 上传前压缩图片
      Toast.loading({
        message: '头像上传中...',
        forbidClick: true, // 禁用背景点击
        loadingType: 'spinner'
      })

      axios.create().post('/uploadPZTXImg', param, {
        xsrfHeaderName: 'Authorization', // 请求头的名字自定义，用你们后台给你的就是
        headers: {
          'Content-Type': 'multipart/form-data',
          'UserToken': localStorage.getItem('UserToken') // 请求头的规则，这个参数必须要传
        } }).then(({ data }) => {
        if (data.code === 200) {
          Toast.clear()// 手动清除 Toast
          this.imgSrc = `${this.setUserImages()}&v=${Math.random() * 10}`
          // this.util.toast(data.msg)
          // console.log(this.imgSrc)
          // this.getimgSrc()
          // location.reload()// 刷新页面
          // alert(file.size)
          // alert(newfiles.size)
        } else {
          return Promise.reject(new Error(data.message || data.msg || '系统错误，请稍后再试。'))
        }
      })
    },
    // 点击触发input的点击事件
    clickFile (e) {
      this.$refs.leftFile.click()
    }

  },
  data () {
    return {
      img: '',
      imgSrc: '',
      cpname: '', // 姓名
      phoneNum: '', // 手机号
      // imgSrc: require('../assets/tx@3x.png'),
      pageHeight: window.innerHeight - 46,
      show: false,
      actions: [
        { name: '拍照' },
        { name: '相册' }
        // { name: '加载选项', loading: true }
      ]
    }
  }
}
</script>

<style scoped lang="less">
/deep/.van-nav-bar__content {
  height: 46px;
}
/deep/.van-nav-bar__title {
  font-size: 17px;
  font-weight: bold;
}
/deep/.van-nav-bar .van-icon {
  font-size: 17px;
  color: #A6A6A6;
}
.hide_file{
    display:none;
}
.camera{
    // position: relative;
    // z-index: 2;
    // margin: 0 auto;
    // margin-bottom: 10px;
    // width: 138px;
    // height: 138px;
    // background: #E7E7E7;
    // border-radius: 6px;
    // text-align: center;
    >div{
      width: 154px;
      height: 154px;
      overflow: hidden;
      border-radius: 50%;
      margin: 0 auto;
    }
    .bigImg{
        width: 154px;
        height: 154px;
    }
    .icon{
        width: 154px;
    }
    .text{
        display: block;
        font-size: 15px;
        margin-top: 40px;
        color:#0B7DEC
    }
}

</style>
